import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './assets/cclogo.png'
import _imports_1 from './assets/smglogo2.png'


const _hoisted_1 = { class: "navbar fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "Custom Controllers Logo"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "Stock Must Go Logo"
}
const _hoisted_6 = { class: "full-height" }
const _hoisted_7 = { class: "navbar navbar-bottom" }
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-6 text-start" }
const _hoisted_11 = { class: "social-icons mb-3" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "col-sm-6 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnRequestForm = _resolveComponent("ReturnRequestForm")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isConfigCC ? 'returnform-cc' : 'returnform-smg')
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: _ctx.mainSiteLink,
          class: "navbar-brand"
        }, [
          (_ctx.isConfigCC)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ], 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ReturnRequestForm, {
        "config-prop": _ctx.config,
        "is-config-c-c-prop": _ctx.isConfigCC
      }, null, 8, ["config-prop", "is-config-c-c-prop"])
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "navbar-brand" }, "Follow us", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                title: "Email",
                href: _ctx.socialLinks.Email,
                class: "social-link",
                target: "_blank"
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M14.5314 16.52C14.4762 16.5754 14.4101 16.6189 14.3374 16.6477C14.2647 16.6765 14.1868 16.6901 14.1086 16.6876C13.9588 16.6855 13.8158 16.6246 13.7105 16.5181L6 8.80762V20.1371H22V8.83619L14.5314 16.52Z",
                    fill: "currentColor"
                  }),
                  _createElementVNode("path", {
                    d: "M21.2171 8H6.80762L14.1143 15.3086L21.2171 8Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_12),
              _createElementVNode("a", {
                title: "Facebook",
                href: _ctx.socialLinks.Facebook,
                class: "social-link",
                target: "_blank"
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M13.591 6.00441C11.5868 6.11515 9.75158 6.92966 8.34448 8.333C7.44444 9.23064 6.78641 10.2982 6.39238 11.5002C6.01229 12.6596 5.90552 13.9193 6.08439 15.1343C6.18456 15.8146 6.36736 16.4631 6.63981 17.1046C6.71166 17.2738 6.89438 17.6476 6.98704 17.815C7.22995 18.2538 7.52906 18.6904 7.84853 19.0725C8.16302 19.4486 8.56717 19.8479 8.94482 20.1556C9.6776 20.7526 10.5183 21.2186 11.4085 21.5211C11.8412 21.6681 12.259 21.7723 12.7342 21.8517L12.751 21.8545V19.0664V16.2783H11.7348H10.7186V15.1231V13.9678H11.7344H12.7503L12.7531 12.9265C12.756 11.8203 12.7553 11.845 12.7927 11.5862C12.9306 10.6339 13.3874 9.91646 14.1198 9.50212C14.4564 9.31168 14.8782 9.18341 15.331 9.13374C15.791 9.0833 16.55 9.12126 17.351 9.23478C17.4659 9.25105 17.5612 9.26437 17.5629 9.26437C17.5646 9.26437 17.566 9.70662 17.566 10.2472V11.2299L16.9679 11.233C16.3284 11.2363 16.299 11.2379 16.1298 11.2771C15.6926 11.3785 15.4015 11.6608 15.2983 12.0834C15.2566 12.2542 15.256 12.2685 15.256 13.1531V13.9678H16.3622C17.3606 13.9678 17.4685 13.9689 17.4685 13.9795C17.4685 13.9921 17.1263 16.2236 17.1191 16.2578L17.1148 16.2783H16.1854H15.256V19.0647V21.8511L15.2954 21.8459C15.4396 21.8271 15.8337 21.7432 16.0548 21.6844C16.5933 21.5411 17.079 21.3576 17.581 21.1076C19.3154 20.2441 20.6895 18.7615 21.4192 16.9663C21.7498 16.153 21.936 15.3195 21.9915 14.4052C22.0028 14.2197 22.0028 13.7268 21.9916 13.5415C21.9403 12.6947 21.7817 11.9389 21.4942 11.1712C20.8665 9.49533 19.6589 8.05123 18.1135 7.12853C17.7376 6.90413 17.2813 6.68103 16.8985 6.53456C16.1262 6.23908 15.3815 6.07432 14.5323 6.01114C14.3897 6.00053 13.7447 5.99591 13.591 6.00441Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_13),
              _createElementVNode("a", {
                title: "Instagram",
                href: _ctx.socialLinks.Instagram,
                class: "social-link",
                target: "_blank"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M11.1213 6.00507C10.5981 6.02559 9.96558 6.0872 9.6431 6.14903C7.77505 6.50724 6.50522 7.77703 6.14804 9.644C6.0118 10.3562 6 10.7031 6 14.0006C6 17.298 6.0118 17.6449 6.14804 18.3572C6.50522 20.2241 7.776 21.4948 9.6431 21.852C10.3554 21.9882 10.7023 22 14 22C17.2977 22 17.6446 21.9882 18.3569 21.852C20.224 21.4948 21.4948 20.2241 21.852 18.3572C21.9882 17.6449 22 17.298 22 14.0006C22 10.7031 21.9882 10.3562 21.852 9.644C21.4935 7.77016 20.2144 6.49675 18.3396 6.14716C17.6551 6.01955 17.3874 6.00985 14.334 6.00234C12.707 5.99836 11.2612 5.99957 11.1213 6.00507ZM17.6262 7.50836C18.2783 7.59344 18.7654 7.73848 19.1427 7.95992C19.3813 8.09994 19.9011 8.61966 20.0411 8.85821C20.2728 9.253 20.4142 9.74012 20.4952 10.4223C20.5551 10.9261 20.5551 17.075 20.4952 17.5789C20.4142 18.261 20.2728 18.7482 20.0411 19.143C19.9011 19.3815 19.3813 19.9012 19.1427 20.0412C18.7479 20.2729 18.2608 20.4143 17.5785 20.4953C17.0747 20.5552 10.9253 20.5552 10.4215 20.4953C9.73923 20.4143 9.25207 20.2729 8.85726 20.0412C8.61869 19.9012 8.09893 19.3815 7.9589 19.143C7.72724 18.7482 7.58578 18.261 7.50476 17.5789C7.44493 17.075 7.44493 10.9261 7.50476 10.4223C7.56313 9.93096 7.62729 9.63856 7.74686 9.31938C7.88402 8.95319 8.02204 8.72965 8.28724 8.44428C8.87822 7.8083 9.55222 7.55184 10.8191 7.48098C11.5114 7.44227 17.2981 7.46552 17.6262 7.50836ZM17.9602 8.80646C17.7222 8.8876 17.4343 9.18659 17.358 9.43194C17.1268 10.175 17.8258 10.874 18.569 10.6429C18.8334 10.5606 19.1165 10.2776 19.1987 10.013C19.2689 9.78758 19.251 9.52441 19.1511 9.31187C19.071 9.14148 18.8248 8.90306 18.6554 8.83162C18.4699 8.75347 18.1498 8.74189 17.9602 8.80646ZM13.6183 9.8962C12.6459 9.99712 11.7694 10.4112 11.0899 11.0907C9.99978 12.1807 9.61075 13.7764 10.076 15.2492C10.4746 16.5107 11.4897 17.5257 12.7513 17.9243C13.5638 18.1809 14.4362 18.1809 15.2487 17.9243C16.5103 17.5257 17.5254 16.5107 17.924 15.2492C18.1806 14.4367 18.1806 13.5644 17.924 12.752C17.5254 11.4904 16.5103 10.4754 15.2487 10.0769C14.7428 9.91709 14.1016 9.84604 13.6183 9.8962ZM14.6362 11.4119C14.9255 11.4811 15.4416 11.7393 15.6794 11.9337C15.9731 12.1738 16.2113 12.4794 16.3856 12.8396C16.5969 13.2766 16.6509 13.5128 16.6509 14.0006C16.6509 14.4884 16.5969 14.7246 16.3856 15.1615C16.1137 15.7235 15.7253 16.1118 15.161 16.3855C14.7247 16.5972 14.4883 16.6513 14 16.6513C13.5117 16.6513 13.2753 16.5972 12.839 16.3855C12.2747 16.1118 11.8863 15.7235 11.6144 15.1615C11.5298 14.9866 11.4355 14.7433 11.4049 14.6208C11.3288 14.3169 11.3288 13.6843 11.4049 13.3803C11.482 13.0724 11.7369 12.5611 11.933 12.3213C12.3447 11.8177 12.9934 11.449 13.6224 11.3611C13.8845 11.3244 14.3734 11.3489 14.6362 11.4119Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_14),
              (!_ctx.isConfigCC)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    title: "Linkedin",
                    href: _ctx.socialLinks.Linkedin,
                    class: "social-link",
                    target: "_blank"
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("svg", {
                      width: "28",
                      height: "28",
                      viewBox: "0 0 28 28",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M14.96 12.4356C15.4151 11.7244 16.2293 10.7307 18.0516 10.7307C20.3076 10.7307 22 12.2044 22 15.3742V21.2889H18.5707V15.7778C18.5707 14.3911 18.0747 13.4436 16.8338 13.4436C15.8862 13.4436 15.3227 14.0818 15.0738 14.6987C14.9856 14.968 14.9471 15.2511 14.96 15.5342V21.2889H11.5289C11.5289 21.2889 11.5751 11.9413 11.5289 10.9778H14.96V12.4356ZM7.94133 6C6.768 6 6 6.76978 6 7.77778C6 8.78578 6.74489 9.55556 7.89511 9.55556H7.91822C9.11467 9.55556 9.85956 8.76267 9.85956 7.77778C9.85956 6.79289 9.11467 6 7.94133 6ZM6.20444 21.2889H9.63378V10.9778H6.20444V21.2889Z",
                        fill: "currentColor"
                      })
                    ], -1)
                  ]), 8, _hoisted_15))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                title: "Tiktok",
                href: _ctx.socialLinks.Tiktok,
                class: "social-link",
                target: "_blank"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M14.4861 5H17.6354C17.6354 5 17.4557 8.79324 22 9.07128V12.0006C22 12.0006 19.5694 12.1396 17.6354 10.7494L17.6671 16.8067C17.6671 17.8913 17.3247 18.9514 16.6832 19.853C16.0418 20.7546 15.1301 21.4572 14.0635 21.8718C12.997 22.2863 11.8235 22.3943 10.6916 22.182C9.55971 21.9697 8.52029 21.4467 7.70487 20.6791C6.88946 19.9115 6.3347 18.9339 6.11081 17.87C5.88691 16.806 6.00395 15.7036 6.44709 14.7022C6.89024 13.7008 7.63959 12.8454 8.6003 12.2443C9.56101 11.6432 10.6899 11.3234 11.8441 11.3254H12.6579V14.3342C12.1269 14.1796 11.5576 14.1863 11.0309 14.3533C10.5043 14.5203 10.0471 14.8392 9.72446 15.2645C9.40182 15.6898 9.23016 16.1999 9.23391 16.7221C9.23766 17.2444 9.41662 17.7523 9.74533 18.1735C10.074 18.5946 10.5358 18.9077 11.0648 19.068C11.5938 19.2284 12.1631 19.2279 12.6918 19.0665C13.2205 18.9052 13.6816 18.5914 14.0094 18.1696C14.3372 17.7478 14.5152 17.2396 14.5178 16.7174L14.4861 5Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_16),
              _createElementVNode("a", {
                title: "Twitter",
                href: _ctx.socialLinks.Twitter,
                class: "social-link",
                target: "_blank"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M16.7107 8.01016C16.0674 8.08828 15.4592 8.34677 14.9808 8.74546C14.3619 9.26117 13.9733 9.932 13.8282 10.735C13.7732 11.0393 13.7814 11.5765 13.8457 11.8826C13.8581 11.9415 13.8648 11.9931 13.8606 11.9973C13.8565 12.0014 13.7526 11.9967 13.6299 11.9867C11.6498 11.8255 9.86436 11.0998 8.32993 9.83247C8.08976 9.63411 7.46709 9.0206 7.25993 8.77819C7.17962 8.68424 7.10806 8.60502 7.10087 8.60215C7.07841 8.59318 6.89133 8.99533 6.82319 9.19908C6.5182 10.1109 6.62714 11.0997 7.12305 11.9207C7.35156 12.299 7.6175 12.5843 8.04875 12.914L8.09561 12.9498L7.96283 12.9404C7.56691 12.9125 7.16242 12.8032 6.79124 12.6238C6.70962 12.5844 6.63644 12.5494 6.62862 12.546C6.60958 12.5379 6.62905 12.8651 6.6599 13.0716C6.85098 14.351 7.82335 15.4305 9.06804 15.7452C9.14752 15.7653 9.21253 15.786 9.21253 15.7913C9.21253 15.8015 9.03887 15.8403 8.86887 15.8681C8.81302 15.8773 8.65134 15.8888 8.50958 15.8937C8.27595 15.9018 8.16933 15.8959 7.85692 15.8577L7.77444 15.8476L7.81534 15.9624C7.88056 16.1455 8.04381 16.4672 8.16129 16.6441C8.72962 17.4998 9.64218 18.0285 10.6963 18.1127L10.8288 18.1233L10.7744 18.169C10.6906 18.2393 10.2073 18.5566 10.0342 18.6548C9.24773 19.1015 8.37784 19.377 7.42859 19.4803C7.13755 19.512 6.46302 19.5159 6.19231 19.4876C6.09057 19.4769 6.00412 19.4714 6.0002 19.4753C5.99011 19.4853 6.36772 19.7084 6.62722 19.8458C7.55676 20.3377 8.59674 20.68 9.63431 20.8355C10.3733 20.9463 11.2677 20.9669 12.04 20.8911C14.1558 20.6832 16.0078 19.839 17.4899 18.4067C19.0217 16.9265 20.0398 14.8743 20.31 12.7228C20.3571 12.3475 20.3722 12.092 20.3731 11.6571L20.3739 11.2127L20.4579 11.1524C20.7159 10.9673 21.1178 10.6063 21.3633 10.3394C21.6026 10.0792 22.0329 9.53139 21.998 9.53139C21.9933 9.53139 21.8754 9.5763 21.7362 9.6312C21.4534 9.74268 21.2125 9.81851 20.8927 9.8968C20.6687 9.95158 20.2052 10.0345 20.1763 10.025C20.1672 10.022 20.208 9.98764 20.2669 9.94871C20.7209 9.64839 21.1173 9.20076 21.3654 8.70831C21.4639 8.5128 21.5639 8.2633 21.5495 8.24903C21.5445 8.24406 21.4849 8.27187 21.4169 8.31084C20.9381 8.58539 20.2815 8.83829 19.6928 8.97486L19.4783 9.02465L19.3156 8.87036C18.8586 8.43683 18.259 8.14443 17.5951 8.03122C17.4261 8.0024 16.8815 7.98943 16.7107 8.01016Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_17),
              _createElementVNode("a", {
                title: "Youtube",
                href: _ctx.socialLinks.Youtube,
                class: "social-link",
                target: "_blank"
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("svg", {
                  width: "28",
                  height: "28",
                  viewBox: "0 0 28 28",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M21.68 10.7286C22 11.9386 22 14.5 22 14.5C22 14.5 22 17.0614 21.68 18.2714C21.5909 18.6122 21.4103 18.9233 21.157 19.1721C20.9037 19.4208 20.587 19.5982 20.24 19.6857C19.008 20 14 20 14 20C14 20 8.992 20 7.76 19.6857C7.41301 19.5982 7.09631 19.4208 6.843 19.1721C6.58968 18.9233 6.40906 18.6122 6.32 18.2714C6 17.0614 6 14.5 6 14.5C6 14.5 6 11.9386 6.32 10.7286C6.512 10.0371 7.056 9.50286 7.76 9.31429C8.992 9 14 9 14 9C14 9 19.008 9 20.24 9.31429C20.944 9.50286 21.488 10.0371 21.68 10.7286ZM12.4 16.8571L16.56 14.5L12.4 12.1429V16.8571Z",
                    fill: "currentColor"
                  })
                ], -1)
              ]), 8, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("small", null, [
              _createTextVNode(" Copyright © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_ctx.siteName) + ". ", 1),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              _cache[9] || (_cache[9] = _createTextVNode("Powered by SK TES Consumer Solutions Ltd | Company REG 8692717 | VAT GB173140925 "))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}